import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from '@stvgroup/stv-ui-components'
import Search from './index'

/**
 * A container that renders the search overlay using MUI Modal.
 * The visibility is controlled by the parent component through the open prop.
 * @param {boolean} open - Flag indicating if the search overlay is active.
 * @param {Function} onClose - Function to call when the modal requests to close.
 * @param {Function} toggleSearch - Function to toggle search visibility (passed down to
 * Search component)
 */
const SearchContainer = ({
  open,
  onClose,
  toggleSearch,
  ...props
}) => (
  <Modal
    open={open}
    onClose={onClose}
    sx={{
      zIndex: 1000,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Search toggleSearch={toggleSearch} {...props} />
  </Modal>
)

SearchContainer.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  toggleSearch: PropTypes.func.isRequired,
}

SearchContainer.defaultProps = {
  open: false,
}

export default SearchContainer
